/**
 * @file Enum input type - select dropdown for enumerated values
 * @version 1.0.0
 */

import { StringInputType } from './string.js';

export const EnumInputType = {
  name: 'enum',
  matches: getAttribute => Array.isArray(getAttribute('enum')),
  displayComponent: StringInputType.displayComponent,
  editComponent: {
    name: 'EnumEdit',
    props: ['value', 'getAttribute', 'validationError'],
    emits: ['input', 'keydown', 'blur'],
    methods: {
      handleInput(event) {
        this.$emit('input', event);
      },
    },
    template: `
      <select
        class="form-select form-select-sm"
        :class="{ 'is-invalid': validationError }"
        :value="value"
        style="min-width: 150px"
        @change="handleInput"
        @blur="$emit('blur', $event)"
      >
        <option :value="undefined">-- Select --</option>
        <option v-for="option in getAttribute('enum')" :key="option" :value="option">
          {{ option }}
        </option>
      </select>
    `,
  },
};

export default EnumInputType;
